import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Constants } from 'src/app/helper/constants';
import { IComplianceTemplate, IAdminTemplateResult, superAdminFilters, IAdminTemplateImageResult } from 'src/app/feature/admin/models/admin';
import { IAdminPermissions, IAdminPermissionsResult, ISuperAdmins } from 'src/app/feature/admin/models/permission';
import { ISiteConfigurationResult, ISiteConfiguration, IPostSiteConfigurationResult } from 'src/app/feature/admin/models/site-configuration';
import { Observable, BehaviorSubject } from 'rxjs';
import * as facility from 'src/app/models/facility';


export interface IUploadResult {
  message?: string;
  validations?: string;
  payload?: any;
}

@Injectable({
  providedIn: 'root'
})
export class AdminService {

  constructor(private httpClient: HttpClient) {
    // Do Nothing
  }

  isLoading = new BehaviorSubject<boolean>(false);


  postMatrixData = (siteObj: IComplianceTemplate, imageByteArray) => {
    const formData = new FormData();
    formData.append('Compliance', JSON.stringify(siteObj));
    formData.append('File', imageByteArray);
    return this.httpClient.post<IUploadResult>(Constants.POST_TEMPLATE, formData, {
      reportProgress: true,
      observe: 'events',
      headers: new HttpHeaders({ 'ngsw-bypass': 'true' })
    });
  }

  getMatrixData = () => {
    return this.httpClient.get<IAdminTemplateResult>(Constants.POST_TEMPLATE);
  }

  deleteMatrixData = (id: number) => {
    return this.httpClient.delete<IAdminTemplateResult>(Constants.POST_TEMPLATE + '/' + id);
  }

  postPermissionData = (permissionObj: IAdminPermissions[]): Observable<IAdminPermissionsResult> => {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const options = { headers };
    return this.httpClient.post(Constants.POST_PERMISSIONS, permissionObj, options);
  }

  getPermissionData = (data: superAdminFilters): Observable<IAdminPermissionsResult> => {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const options = { headers };
    return this.httpClient.post(Constants.GET_PERMISSIONS, data, options);
  }

  postSuperAdminPermissionData = (data: superAdminFilters): Observable<IAdminPermissionsResult> => {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const options = { headers };
    return this.httpClient.post(Constants.GET_SUPER_ADMIN_PERMISSIONS, data, options);
  }

  postSuperAdminPermissionFaciltiesData = (data: superAdminFilters): Observable<facility.IFacility> => {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const options = { headers };
    return this.httpClient.post<facility.IFacility>(Constants.GET_SUPER_ADMIN_PERMISSIONS_FACILTIES, data, options);
  }

  getSuperAdmins = (): Observable<ISuperAdmins> => {
    return this.httpClient.get<ISuperAdmins>(Constants.GET_SUPER_ADMIN_USERS);
  }

  deletePermissionData = (id: string) => {
    return this.httpClient.delete<IAdminPermissionsResult>(Constants.POST_PERMISSIONS + '?transactionId=' + id);
  }

  getAllFacilityConfigurations = (): Observable<ISiteConfigurationResult> => {
    return this.httpClient.get<ISiteConfigurationResult>(Constants.GET_FACILITIES_ADMIN_CONFIGURATION);
  }
  postFacilityConfigurations = (obj: ISiteConfiguration): Observable<IPostSiteConfigurationResult> => {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const options = { headers };
    return this.httpClient.post<IPostSiteConfigurationResult>(Constants.POST_FACILITIES_ADMIN_CONFIGURATION, obj, options);
  }

  setIsLoading(value: boolean) {
    this.isLoading.next(value);
  }
  getIsLoading = (): Observable<boolean> => {
    return this.isLoading.asObservable();
  }

  getConfigurationImage = (id: number): Observable<IAdminTemplateImageResult> => {
    return this.httpClient.get<IAdminTemplateImageResult>(Constants.GET_ADMIN_COMPLIANCE_IMAGE + id.toString() + "/image");
  }
}
